(function () {
  if (window.__szhProductShareBound) return;
  window.__szhProductShareBound = true;

  function closeMenus() {
    document.querySelectorAll('[data-szh-product-share]').forEach(function (root) {
      var menu = root.querySelector('[data-szh-share-menu]');
      var trigger = root.querySelector('[data-szh-share-trigger]');
      if (menu) menu.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function copyFallback(value) {
    var input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    var copied = false;
    try { copied = document.execCommand('copy'); } catch (error) { copied = false; }
    input.remove();
    return copied;
  }

  document.addEventListener('click', async function (event) {
    var trigger = event.target.closest('[data-szh-share-trigger]');
    if (trigger) {
      event.preventDefault();
      var root = trigger.closest('[data-szh-product-share]');
      if (!root) return;
      var menu = root.querySelector('[data-szh-share-menu]');
      if (!menu) return;
      var wasClosed = menu.hidden;
      closeMenus();
      if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
        try {
          await navigator.share({ title: root.dataset.shareTitle, url: root.dataset.shareUrl });
        } catch (error) {
          if (error && error.name !== 'AbortError') {
            menu.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
          }
        }
      } else {
        menu.hidden = !wasClosed;
        trigger.setAttribute('aria-expanded', wasClosed ? 'true' : 'false');
      }
      return;
    }

    var copy = event.target.closest('[data-szh-share-copy]');
    if (copy) {
      event.preventDefault();
      var box = copy.closest('[data-szh-product-share]');
      if (!box) return;
      var value = box.dataset.shareUrl;
      var success = false;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try { await navigator.clipboard.writeText(value); success = true; } catch (error) {}
      }
      if (!success) success = copyFallback(value);
      if (success) {
        var status = box.querySelector('[data-szh-share-status]');
        if (status) status.textContent = box.dataset.shareCopied;
        closeMenus();
      }
      return;
    }

    if (!event.target.closest('[data-szh-product-share]')) closeMenus();
    else if (event.target.closest('a')) closeMenus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-szh-share-trigger][aria-expanded="true"]');
    if (open) {
      closeMenus();
      open.focus();
    }
  });
})();